import { render, staticRenderFns } from "./AppointmentRequestIndex.vue?vue&type=template&id=1951cfc1&scoped=true&"
import script from "./AppointmentRequestIndex.vue?vue&type=script&lang=js&"
export * from "./AppointmentRequestIndex.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentRequestIndex.vue?vue&type=style&index=0&id=1951cfc1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1951cfc1",
  null
  
)

export default component.exports